import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { SelectTimeInterface } from "@/components/Home/Services/ServiceTimeSelect/SelectTimeInterface";
import { MutationTree } from "vuex";
import { ServiceScheduleState } from "./types";

export const mutations: MutationTree<ServiceScheduleState> = {
  setTime(state, payload: SelectTimeInterface) {
    state.time = payload;
  },
  setDate(state, payload: string) {
    state.date = payload;
  },
  setSearchDate(state, payload: string) {
    state.searchDate = payload;
  },
  setClinicId(state, payload: string) {
    state.clinicId = payload;
  },
  setService(state, payload: ServiceInterface) {
    state.service = payload;
  },
  setCpf(state, payload: string) {
    state.cpf = payload;
  },
  setAppointmentDate(state, payload: string) {
    state.appointmentDate = payload;
  },
  setPatient(state, payload: PatientInterface) {
    state.patient = payload;
  },
  setFormPatientData(state, payload: { [index: string]: string | number }) {
    state.formPatientData = payload;
  },
  resetState(state) {
    state.clinicId = "";
    state.time = null;
    state.service = null;
    state.cpf = "";
    state.appointmentDate = "";
    state.patient = null;
    state.formPatientData = {};
  },
};
